import React, { useEffect } from "react";
import { getAPIURLAWS, getUserID } from "../../../../services/helper";
import {
  setConnected,
  setSocket,
  setConnectionId,
  replyByUserAsync,
  setMemberStatusById,
  incrementUnreadCount,
  resetUnreadCount, // Assuming you have an action for storing connectionId
} from "../../../../ReduxToolkit/Reducers/ChatReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import http from "../../../../services/http";

const current_user_id = getUserID();
const api_url = getAPIURLAWS();
export default function WebSocketManager() {
  const dispatch = useDispatch();
  const { chats, selectedGroup, currentUser, selectedUser } = useSelector(
    (state) => state.chat
  );

  useEffect(() => {
    const resetUnreadListener = () => {
      dispatch(resetUnreadCount());
    };

    window.addEventListener("chatOpened", resetUnreadListener);

    return () => {
      window.removeEventListener("chatOpened", resetUnreadListener);
    };
  }, [dispatch]);

  useEffect(() => {
    if (!current_user_id) {
      console.error("User ID is not available for WebSocket connection");
      return;
    }

    // Initialize WebSocket when the component mounts
    const newSocket = new WebSocket(
      `wss://b6drqdz6p7.execute-api.us-east-1.amazonaws.com/production/?userId=${current_user_id}`
    );

    newSocket.onopen = () => {
      console.log("Connected to WebSocket");
      dispatch(setConnected(true));

      let payload = {
        action: "setMemberStatus",
        type: "status_update",
        userId: current_user_id,
        status: "online",
      };

      newSocket.send(JSON.stringify(payload));
    };

    newSocket.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        const {
          recipient: currentUserId,
          sender: selectedUserId,
          message: replyMessage,
          groupId,
          type,
          meta,
          userId,
          status,
          PK,
          SK,
        } = data;

        // Check if it's a group chat or private chat
        const isRecipient =
          groupId && Array.isArray(currentUserId)
            ? currentUserId.includes(Number(current_user_id)) &&
              selectedUserId !== Number(current_user_id)
            : Number(current_user_id) === currentUserId; // For private chat, match directly

        // console.log("isRecipient", isRecipient);
        if (isRecipient) {
          // Check if the message belongs to the currently selected chat
          const isCurrentChat =
            selectedGroup?.groupId === groupId ||
            (selectedUserId && selectedUser?.id === selectedUserId);

          if (!isCurrentChat) {
            console.log("incremnt");
            dispatch(incrementUnreadCount());
          }

          // Handle the new message logic
          dispatch(
            replyByUserAsync({
              currentUserId,
              selectedUserId,
              replyMessage,
              PK,
              SK,
              type,
              meta,
              chats,
            })
          );
        }

        // If connectionId is received, store it
        if (data.connectionId) {
          dispatch(setConnectionId(data.connectionId));
        }
      } catch (error) {
        console.error("Error parsing message from server:", error);
      }
    };

    newSocket.onclose = async () => {
      // console.log(`Disconnected from WebSocket`, newSocket);
      dispatch(setConnected(false));
      dispatch(setConnectionId(""));
      dispatch(setSocket(null));

      try {
        await http.delete(`${api_url}/chats/connections`, {
          data: { user_id: current_user_id },
        });
        console.log(`all connections removed for user ${current_user_id}`);
      } catch (e) {
        console.error("Error while deleting group", e);
      }
    };

    newSocket.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };

    // Set the socket state in Redux or wherever needed
    dispatch(setSocket(newSocket));

    // Cleanup WebSocket connection on component unmount
    return () => {
      if (newSocket) {
        let payload = {
          action: "setMemberStatus",
          type: "status_update",
          userId: current_user_id,
          status: "offline",
        };

        newSocket.send(JSON.stringify(payload));

        newSocket.close();
        dispatch(setSocket(null));
      }
    };
  }, [current_user_id, dispatch]); // Ensure it runs when the component mounts, with current_user_id dependency

  return null; // This component just manages the WebSocket connection
}
